/**
 * The barge-in bench's "Play AI voice" phrase, kept in this browser so the TTS call is paid for
 * once and the audio reused from then on. Keyed by provider + voice + language + phrase, so
 * changing the default provider/voice/language (or the phrase) synthesizes — and caches — a new one.
 */
const PREFIX = 'barge-in-ai-voice:v1:';
export const aiVoiceCacheKey = (providerId, voice, language, phrase) => [providerId, voice !== null && voice !== void 0 ? voice : '', language !== null && language !== void 0 ? language : '', phrase].join('|');
export const readCachedAiVoice = (key) => {
    var _a;
    try {
        const raw = window.localStorage.getItem(PREFIX + key);
        const parsed = raw ? JSON.parse(raw) : null;
        return ((_a = parsed === null || parsed === void 0 ? void 0 : parsed.chunks) === null || _a === void 0 ? void 0 : _a.length) ? parsed : null;
    }
    catch (_b) {
        return null;
    }
};
export const writeCachedAiVoice = (key, value) => {
    try {
        window.localStorage.setItem(PREFIX + key, JSON.stringify(value));
    }
    catch (_a) {
        // Storage full or blocked: the next play simply synthesizes again.
    }
};
